// Base button style with CSS variables
export const buttonBaseStyle = "btn inline-flex items-center justify-center border border-transparent font-medium text-white";

// Disabled button style
export const buttonDisabledStyle = "bg-gray-400 cursor-not-allowed opacity-60";

// Button variants using CSS variables
export const buttonVariants = {
  submit: `${buttonBaseStyle} btn-primary`,
  save: `${buttonBaseStyle} btn-success`,
  restart: `${buttonBaseStyle} btn-danger`,
};
